import styled from 'styled-components';

import WaitingListComponent from 'components/b2b/WaitingList';
import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing } from 'stylesheetB2b';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
LayoutContainer.displayName = 'LayoutContainer';

export const ContentArea = styled.div`
  flex: 2;

  /*
    We override the min-width: auto property on flex elements
    to avoid the ContentArea to take the width of its children
    in case of overflow.
    This is needed for example to truncate the artist name in the
    SongsList component
  */
  min-width: 0;
`;
ContentArea.displayName = 'ContentArea';

export const WaitingList = styled(WaitingListComponent)`
  flex: 1;
  max-width: ${getSpacing(60)};

  /*
    We override the min-width: auto property on flex elements
    to avoid the ContentArea to take the width of its children
    in case of overflow.
    This is needed for example to truncate the artist name in the
    SongsList component
  */
  min-width: 0;
`;
WaitingList.displayName = 'WaitingList';

export const NavigationArea = styled.div<{ colors: ColormapInterface; }>`
  display: flex;
  flex: 1;
  overflow: hidden;
  ${({ colors }) => `
    border-right: solid ${getSpacing(0.2)} ${colors.homeBorder};
    border-left: solid ${getSpacing(0.2)} ${colors.homeBorder};
    `}
`;
NavigationArea.displayName = 'NavigationArea';
